import * as React from "react";
import { DnsConfig } from "./dnsConfig";
import { useCpFormValue } from "../../gvc/testNewForm/utils";
import { CardContent } from "../../../components/antd/card/CardContent";
import { Card } from "antd";

interface Props extends React.PropsWithChildren {}
export const DnsConfigAdvanced: React.FC<Props> = () => {
  const dns = useCpFormValue(`meta.dryRun.dns`);

  if (!dns || dns.length < 1) {
    return null;
  }

  return (
    <div className="cpln-form-section cpln-ant-card-container" data-section-id={`dns-config`}>
      <Card>
        <CardContent>
          <DnsConfig />
        </CardContent>
      </Card>
    </div>
  );
};
